{
  "it": {
    "form": {
      "actions": {
        "cancel": "Annulla",
        "clear": "Svuota",
        "closeFullPage": "Chiudi pagina intera",
        "copyText": "Faccia clic per copiare il testo",
        "create_and_send_to_customer": "Crea e invia al cliente",
        "create_and_share": "Crea e condividi con il cliente",
        "create_and_share_partners_only": "Crea e condividi con i partner",
        "create_and_share_with_partners": "Crea e condividi con cliente e partner",
        "next": "Avanti",
        "only_create": "Crea soltanto",
        "openFullPage": "Apri a pagina intera",
        "save": "Salva",
        "saveChanges": "Salva modifiche",
        "search": "Cerca...",
        "send": "Invia",
        "send_and_create_another": "Invia e crea un altro",
        "send_to_customer": "Invia al cliente",
        "share_with_customer": "Condividi con il cliente",
        "submit": "Salva",
        "submit_and_create_another": "Salva e crea un altro"
      },
      "back": "Passaggio precedente",
      "labels": {
        "columns": "Colonne",
        "from": "Da",
        "no_results": "Nessun risultato",
        "optional": "(facoltativo)",
        "to": "A"
      },
      "notifications": {
        "textHasBeenCopied": "Il testo è stato copiato"
      },
      "password": "Password",
      "shortcuts": {
        "save_mac": "⌘ + Invio per salvare",
        "save_windows": "Ctrl + Invio per salvare",
        "send_mac": "⌘ + Invio per inviare",
        "send_windows": "Ctrl + Invio per inviare"
      },
      "steps": "Passaggio {count} di {total}",
      "writeEmployeeNameReject": "Scriva <i><b>{employeeName}</b></i> per continuare."
    }
  }
}
